import ReactFullpage from "@fullpage/react-fullpage";
import EndSection from "../../Sections/EndSection";
import React, {useEffect, useState} from "react";
import {Col, Row} from "antd";
import CityDropdown from "../../CityDropdown";
import Slider from "react-slick";
import Card from "../../Sections/LatestEventsSection/Card";
import Carousel from "../../Sections/LatestEventsSection/Carousel";
import "./index.less"
import "./indexMobile.less"
import {isMobile} from "react-device-detect";

const PageContent = () => {
    const cities = {
        '中国': ['全国'],
        '长沙': ['长沙'],
        '西安': ['西安'],
        '哈尔滨': ['哈尔滨'],
        '南宁': ['南宁'],
        '徐州': ['徐州'],
        '沈阳': ['沈阳'],
        '石家庄': ['石家庄'],
        '长春': ['长春'],
        '重庆': ['重庆'],
        '昆明': ['昆明'],
        '北京': ['北京'],
        '济宁': ['济宁'],
        '保定': ['保定'],
        '横百': ['横百'],
        '邢台': ['邢台'],
        '成都': ['成都'],
        '贵阳': ['贵阳'],
        '遵义': ['遵义'],
    };

    function SampleNextArrow(props) {
        const {className, style, onClick} = props;
        return (
            <div className={className} style={{...style, position: "absolute", right: "60px", top: "40%", zIndex: 20}}
                 onClick={onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle opacity="0.45" cx="32" cy="32" r="32" fill="black"/>
                    <path d="M14 32H49.5C46 32.3333 39 34.9 39 42.5" stroke="white" stroke-width="2"/>
                </svg>
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const {className, style, onClick} = props;
        return (
            <div className={className} style={{...style, position: "absolute", left: "20px", top: "40%", zIndex: "20"}}
                 onClick={onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle opacity="0.45" cx="32" cy="32" r="32" fill="black"/>
                    <path d="M49.5 32H14C17.5 32.3333 24.5 34.9 24.5 42.5" stroke="white" stroke-width="2"/>
                </svg>
            </div>
        );
    }

    const [settings, setSettings] = useState({
        dots: false,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '90px',
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>
    });

    const [showCards, setShowCards] = useState([]);


    const cardItems = {
        "中国": {
            "全国": [
                {
                    date: "",
                    title: "上海店",
                    desc: "",
                    imageUrl: "/cardCovers/cover1.png"
                }
            ]
        },
        "长沙": {
            "长沙": [
                {
                    date: "",
                    title: "长沙IFS店",
                    desc: "",
                    imageUrl: "/storeImgs/style_cs_ifs.png"
                },
                {
                    date: "",
                    title: "长沙时代奥莱店",
                    desc: "",
                    imageUrl: "/cardCovers/cover1.png"
                }
            ]
        },
        "西安": {
            "西安": [{
                date: "",
                title: "西安赛格店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "西安首创奥莱店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            },
            ]
        },
        "哈尔滨": {
            "哈尔滨": [{
                date: "",
                title: "哈尔滨远大店",
                desc: "",
                imageUrl: "/storeImgs/style_hrb_ngyd.png"
            }, {
                date: "",
                title: "哈尔滨枫叶奥菜店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "哈尔滨杉杉奥菜店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "南宁": {
            "南宁": [{
                date: "",
                title: "南宁杉杉奥菜店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "徐州": {
            "徐州": [{
                date: "",
                title: "徐州杉杉奥菜店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "沈阳": {
            "沈阳": [{
                date: "",
                title: "沈阳盛京大奥菜店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "长春": {
            "长春": [{
                date: "",
                title: "长春欧业商都店",
                desc: "",
                imageUrl: "/storeImgs/style_cc_oysd.png"
            }]
        },
        "重庆": {
            "重庆": [{
                date: "",
                title: "重庆砂之船奥菜店",
                desc: "",
                imageUrl: "/storeImgs/style_cq_bctj.jpg"
            }, {
                date: "",
                title: "重庆北城店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "昆明": {
            "昆明": [{
                date: "",
                title: "昆明首创奥莱店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "北京": {
            "北京": [{
                date: "",
                title: "北京世纪金源店",
                desc: "",
                imageUrl: "/storeImgs/style_bj_sjjy.png"
            }, {
                date: "",
                title: "北京惠多港奥莱店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "北京万达店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "北京君太店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            },]
        },
        "济宁": {
            "济宁": [{
                date: "",
                title: "济宁枫叶店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "保定": {
            "保定": [{
                date: "",
                title: "保定万博店",
                desc: "",
                imageUrl: "/storeImgs/style_bd_wb.jpg"
            }, {
                date: "",
                title: "保定先天下店",
                desc: "",
                imageUrl: "/storeImgs/style_bd_xtx.png"
            }]
        },
        "横百": {
            "横百": [{
                date: "",
                title: "横百国际店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "石家庄": {
            "石家庄": [{
                date: "",
                title: "石家庄泰勒店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "石家庄万象城店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "石家庄北国店",
                desc: "",
                imageUrl: "/storeImgs/style_sjz_bg.png"
            },]
        },
        "邢台": {
            "邢台": [{
                date: "",
                title: "邢台天一城店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "成都": {
            "成都": [{
                date: "",
                title: "成都晶融汇店",
                desc: "",
                imageUrl: "/storeImgs/style_cd_jrh.png"
            }]
        },
        "贵阳": {
            "贵阳": [{
                date: "",
                title: "贵阳亨特店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "贵阳砂之船店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
        "遵义": {
            "遵义": [{
                date: "",
                title: "遵义亨特店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }, {
                date: "",
                title: "遵义国贸店",
                desc: "",
                imageUrl: "/cardCovers/cover1.png"
            }]
        },
    };

    const initCard = () => {
        let datas = [];

        for (let key in cardItems) {
            for (let key2 in cardItems[key]) {
                datas = datas.concat(cardItems[key][key2]);
            }
        }

        setShowCards(datas);
    }

    useEffect(() => {
        initCard();

        // 打印屏幕可见内容高度
        // alert(document.documentElement.clientHeight)
    }, [])

    return <>

        {!isMobile && <div className={"section brandOriginContainer"}>

            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer storeStyleTitle"}>
                <div className={"desc"}>
                    Store Style
                </div>
                <div className={"title"}>
                    店铺风采
                </div>
            </div>

            <div className={"cityDropdownDiv"}>
                <Row justify={"center"} style={{marginTop: "-5px"}}>
                    <Col>
                        <CityDropdown OnSelect={(province, city) => {
                            console.log(province, city);
                            if (province == "中国" && city == "全国") {
                                initCard();
                                return;
                            }
                            setShowCards(cardItems[province][city]);
                        }} cities={cities} defaultSelect={{province: "中国", city: "全国"}}/>
                    </Col>
                </Row>
            </div>

            <div className={"carouselDiv"} style={{display: "flex", justifyContent: "center", marginTop: "160px"}}>
                {showCards.length === 0 && <div>暂无数据</div>}
                {showCards.length > 0 && (
                    <>
                        <Carousel
                            // buttonText={"立即导航"}
                            contentClassName={"ss-card-content"}
                            cardClassName={"ss-card"}
                            // contentStyle={{marginTop: "-90px"}}
                            items={showCards}/>
                    </>
                )}
            </div>
        </div>}

        {isMobile && <div className={"section brandOriginContainer-mobile"}>

            <div className={"topBg"}></div>
            <div className={"cc-topBg2"}></div>

            <img src="/HomeLogoTemp.png" className="rightIcon rightIcon-mobile" draggable="false"/>

            <div className={"topBg topBg-2-p"}></div>
            <div className={"cc-topBg2 cc-topBg2-p"}></div>

            <div className={"topBgMask"}></div>

            <div className={"titleContainer"}>
                <div className={"desc desc-mobile"}>
                    Store Style
                </div>
                <div className={"title title-mobile"}>
                    店铺风采
                </div>
            </div>

            <div className={"cityDropdownDiv"}>
                <Row justify={"center"}>
                    <Col>
                        <CityDropdown OnSelect={(province, city) => {
                            console.log(province, city);
                            if (province == "中国" && city == "全国") {
                                initCard();
                                return;
                            }
                            setShowCards(cardItems[province][city]);
                        }} cities={cities} defaultSelect={{province: "中国", city: "全国"}}/>
                    </Col>
                </Row>
            </div>

            <div className={"carouselDiv carouselDiv-mobile"}
                 style={{display: "flex", justifyContent: "center", marginTop: "180px"}}>
                {showCards.length === 0 && <div>暂无数据</div>}
                {showCards.length > 0 && (
                    <>
                        <Carousel
                            // buttonText={"立即导航"}
                            contentClassName={"ss-card-content"}
                            cardClassName={"ss-card"}
                            contentStyle={document.documentElement.clientHeight <= 700 ? {top: "-40px"} : {top: "-120px"}}
                            styleData={
                                (document.documentElement.clientHeight <= 700 ? {
                                    width: "342px",
                                    height: "210px",
                                } : {
                                    width: "342px",
                                    height: "367px"
                                })
                            }
                            items={showCards}/>
                    </>
                )}
            </div>
        </div>}

    </>
}

export default () => {

    useEffect(() => {
        const watermark = document.querySelector(".fp-watermark");
        watermark && watermark.remove();
    }, [])

    return <div>
        <ReactFullpage
            licenseKey={'YOUR_KEY_HERE'}
            scrollingSpeed={1000}
            loopTop={false}
            loopBottom={false}
            scrollOverflow={true}
            anchors={['ss1', 'ss2']}
            render={({state, fullpageApi}) => {
                return (
                    <ReactFullpage.Wrapper>
                        <PageContent/>
                        <EndSection/>
                    </ReactFullpage.Wrapper>
                );
            }}
        />
    </div>
}